const SessionStorageService = {
  saveItem(key, value) {
    sessionStorage.setItem(key, value);
  },
  getItem(key) {
    return sessionStorage.getItem(key);
  },
  deleteItem(key) {
    sessionStorage.removeItem(key);
  },
  clearSessionStorage() {
    sessionStorage.clear();
  }
};

export default SessionStorageService;



/** WEBPACK FOOTER **
 ** ./src/services/sessionStorage/sessionStorageService.js
 **/